import { createSlice } from '@reduxjs/toolkit';

export interface IExportState {
    isPending: boolean;
    isExportModalOpen: boolean;
    exportFunction?: string;
    query: string;
    fileName: string;
    errors?: any;
}

const initialState: IExportState = {
    isPending: false,
    isExportModalOpen: false,
    query: '',
    fileName: '',
    errors: undefined,
};

export const exportSlice = createSlice({
    name: 'export',
    initialState,
    reducers: {
        showExportModal: (state) => {
            state.isExportModalOpen = true;
        },
        hideExportModal: (state) => {
            state.isExportModalOpen = false;
        },
        setDataGetter: (state, action) => {
            state.query = action.payload.query;
            state.fileName = action.payload.fileName;
        },
    },
});

export const { showExportModal, hideExportModal, setDataGetter } = exportSlice.actions;

export default exportSlice.reducer;
